import createIcon from '../../createIcon';

/**
 * @component @name StoreMallDirectory
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0VjZIMjBWNFpNMjEgMTRWMTJMMjAgN0g0TDMgMTJWMTRINFYyMEgxNFYxNEgxOFYyMEgyMFYxNEgyMVpNMTIgMThINlYxNEgxMlYxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StoreMallDirectory = createIcon('StoreMallDirectory', [
  [
    'path',
    {
      d: 'M20 4H4V6H20V4ZM21 14V12L20 7H4L3 12V14H4V20H14V14H18V20H20V14H21ZM12 18H6V14H12V18Z',
      key: '9fk1xm',
    },
  ],
]);

export default StoreMallDirectory;
